import { CalculationParameterEntryStatus } from "@/api";

export const PercentageMax = 100;
export const DecimalScale = 2;

export interface ParameterEntryFormValues {
  rowKey: string;
  id: string | null;
  effectiveFrom: Date | null;
  value: number | null;
  status: CalculationParameterEntryStatus | null;
}

export interface ParameterFormValues {
  entries: ParameterEntryFormValues[];
}
